module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "StudentProfile"
  }, [_c('h1', {
    staticClass: "m-label",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("\n    生徒基本情報\n  ")]), _vm._v(" "), (_vm.student.id == _vm.edit_id.student_id) ? [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.patchStudent(_vm.student)
      }
    }
  }, [_c('div', {
    staticClass: "m-box__inner"
  }, [_c('table', {
    staticClass: "m-detail"
  }, [(!_vm.valid) ? [_c('tr', [_c('th', [_vm._v("エラー")]), _vm._v(" "), _c('td', {
    staticClass: "errors"
  }, [_c('div', [_vm._v(_vm._s(_vm.errors) + "が入力されていません")])])])] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v("状態")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.state,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "状態"
    },
    model: {
      value: (_vm.watch.state),
      callback: function($$v) {
        _vm.$set(_vm.watch, "state", $$v)
      },
      expression: "watch.state"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("名前")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.f_name),
      expression: "student.f_name"
    }],
    staticClass: "name_w",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.student.f_name)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "f_name", $event.target.value)
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.l_name),
      expression: "student.l_name"
    }],
    staticClass: "name_w",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.student.l_name)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "l_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("かな")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.f_name_kana),
      expression: "student.f_name_kana"
    }],
    staticClass: "name_w",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.student.f_name_kana)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "f_name_kana", $event.target.value)
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.l_name_kana),
      expression: "student.l_name_kana"
    }],
    staticClass: "name_w",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.student.l_name_kana)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "l_name_kana", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("性別")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.gender,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "性別"
    },
    model: {
      value: (_vm.watch.gender),
      callback: function($$v) {
        _vm.$set(_vm.watch, "gender", $$v)
      },
      expression: "watch.gender"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("生年月日")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.birthday),
      expression: "student.birthday"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "生年月日"
    },
    domProps: {
      "value": (_vm.student.birthday)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "birthday", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("年齢")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "calc"
  }, [_vm._v(_vm._s(_vm.calcAge))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("公/国/私")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.school_type,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "公/国/私"
    },
    model: {
      value: (_vm.watch.school_type),
      callback: function($$v) {
        _vm.$set(_vm.watch, "school_type", $$v)
      },
      expression: "watch.school_type"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("学校名")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.school_name),
      expression: "student.school_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.student.school_name)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "school_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("学年")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "calc"
  }, [_vm._v(_vm._s(_vm.calcGrade))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("留年・浪人")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.grade_flag),
      expression: "student.grade_flag"
    }],
    attrs: {
      "type": "number",
      "placeholder": "留年・浪人"
    },
    domProps: {
      "value": (_vm.student.grade_flag)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "grade_flag", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("指導詳細")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.guidance_detail),
      expression: "student.guidance_detail"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.student.guidance_detail)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "guidance_detail", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("次回引継時期")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.takeover_time),
      expression: "student.takeover_time"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "次回引継時期"
    },
    domProps: {
      "value": (_vm.student.takeover_time)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "takeover_time", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("引継結果")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.inheritance_result,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "引継結果"
    },
    model: {
      value: (_vm.watch.inheritance_result),
      callback: function($$v) {
        _vm.$set(_vm.watch, "inheritance_result", $$v)
      },
      expression: "watch.inheritance_result"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("次回TEL日")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.next_contact_date),
      expression: "student.next_contact_date"
    }],
    attrs: {
      "type": "text",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "次回TEL日"
    },
    domProps: {
      "value": (_vm.student.next_contact_date)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "next_contact_date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("優先度")]), _vm._v(" "), _c('td', [_c('multiselect', {
    attrs: {
      "options": _vm.priority,
      "label": "name",
      "searchable": false,
      "show-labels": false,
      "placeholder": "優先度"
    },
    model: {
      value: (_vm.watch.priority),
      callback: function($$v) {
        _vm.$set(_vm.watch, "priority", $$v)
      },
      expression: "watch.priority"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("役務開始")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.service_period_start),
      expression: "student.service_period_start"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "役務開始"
    },
    domProps: {
      "value": (_vm.student.service_period_start)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "service_period_start", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "req"
  }, [_vm._v("役務終了")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.service_period_end),
      expression: "student.service_period_end"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "maxlength": "10",
      "minlength": "10",
      "placeholder": "役務終了"
    },
    domProps: {
      "value": (_vm.student.service_period_end)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "service_period_end", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("備考")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.note),
      expression: "student.note"
    }],
    domProps: {
      "value": (_vm.student.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "note", $event.target.value)
      }
    }
  })])])], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('btn', {
    staticClass: "m-btn m-btn--default"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("更新")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn m-btn--default cancel",
    attrs: {
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelStudent(_vm.student)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("キャンセル")])], 1)])] : _vm._e(), _vm._v(" "), (_vm.student.id !== _vm.edit_id.student_id) ? [_c('div', {
    staticClass: "m-box__inner"
  }, [_c('table', {
    staticClass: "m-detail"
  }, [(!_vm.valid) ? [_c('tr', [_c('th', [_vm._v("エラー")]), _vm._v(" "), _c('td', {
    staticClass: "errors"
  }, [_c('div', [_vm._v(_vm._s(_vm.errors) + "が入力されていません")])])])] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v("状態")]), _vm._v(" "), (_vm.student.state === 0) ? _c('td', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.student.state === 1) ? _c('td', [_vm._v("指導中")]) : _vm._e(), _vm._v(" "), (_vm.student.state === 2) ? _c('td', [_vm._v("休止")]) : _vm._e(), _vm._v(" "), (_vm.student.state === 3) ? _c('td', [_vm._v("CXL")]) : _vm._e(), _vm._v(" "), (_vm.student.state === 4) ? _c('td', [_vm._v("終了")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("名前")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.f_name) + " " + _vm._s(_vm.student.l_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("かな")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.f_name_kana) + " " + _vm._s(_vm.student.l_name_kana))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("性別")]), _vm._v(" "), (_vm.student.gender === 0) ? _c('td', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.student.gender === 1) ? _c('td', [_vm._v("男")]) : _vm._e(), _vm._v(" "), (_vm.student.gender === 2) ? _c('td', [_vm._v("女")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("生年月日")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.student.birthday))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("年齢")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.calcAge))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("公/国/私")]), _vm._v(" "), (_vm.student.school_type === 0) ? _c('td', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.student.school_type === 1) ? _c('td', [_vm._v("公立")]) : _vm._e(), _vm._v(" "), (_vm.student.school_type === 2) ? _c('td', [_vm._v("国立")]) : _vm._e(), _vm._v(" "), (_vm.student.school_type === 3) ? _c('td', [_vm._v("私立")]) : _vm._e(), _vm._v(" "), (_vm.student.school_type === 4) ? _c('td', [_vm._v("その他")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("学校名")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.school_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("学年")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.calcGrade))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("留年・浪人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.grade_flag))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("指導詳細")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.guidance_detail))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("次回引継時期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.takeover_time))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("引継結果")]), _vm._v(" "), (_vm.student.inheritance_result === 0) ? _c('td') : _vm._e(), _vm._v(" "), (_vm.student.inheritance_result === 1) ? _c('td', [_vm._v("成功")]) : _vm._e(), _vm._v(" "), (_vm.student.inheritance_result === 2) ? _c('td', [_vm._v("失敗")]) : _vm._e(), _vm._v(" "), (_vm.student.inheritance_result === 3) ? _c('td', [_vm._v("保留")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("次回TEL日")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.next_contact_date))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("優先度")]), _vm._v(" "), (_vm.student.priority === 0) ? _c('td', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (_vm.student.priority === 1) ? _c('td', [_vm._v("メイン")]) : _vm._e(), _vm._v(" "), (_vm.student.priority === 2) ? _c('td', [_vm._v("サブ")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("役務開始")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.service_period_start))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("役務終了")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.service_period_end))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("備考")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.student.note))])])], 2)]), _vm._v(" "), _c('btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.edit(_vm.student)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v("編集")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46427615"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Profile/StudentProfile.vue
// module id = 1364
// module chunks = 0